import React, { useState } from "react";
import { userServices } from "@services";

export default function UserNotificationMessage() {
  const [needUpdate, setNeedUpdate] = useState(true);
  const [data, setData] = useState(null);

  const user = userServices.getUser();

  if (needUpdate && !user.isGuest()) {
    setNeedUpdate(false);
    userServices.getMessages().then((response) => {
      setData(response);
    });
  }

  if (data) {
    let messages = data.map((d) => {
      return (
        <div className="user-notification">
          <p className="user-notification__text">{d.subject}</p>
        </div>
      );
    });
    return messages;
  }
  return null;
}
